import { displayAccountLabel } from "@common/helpers/accounting";
import {
    useWorkspaceAccounts,
    useWorkspaceAccrualAccounts,
} from "@api/account.api";
import { useShowAccountNumbers } from "@hooks/useShowAccountNumbers";
import { BulkUpdateParams } from "../../transactions/TransactionsBulkActions/lib";

export function useAccountLabelForValueToAssign(
    valueToAssign: BulkUpdateParams,
): string | undefined {
    const isCashAccount = valueToAssign.update === "coa";
    const isAccrualAccount = valueToAssign.update === "accrualCoa";
    const showAccountNumbers = useShowAccountNumbers();
    const { data: cashAccounts } = useWorkspaceAccounts({
        enabled: isCashAccount,
    });
    const { data: accrualAccounts } = useWorkspaceAccrualAccounts({
        enabled: isAccrualAccount,
    });

    if (!isCashAccount && !isAccrualAccount) {
        return undefined;
    }
    const accounts = isCashAccount ? cashAccounts : accrualAccounts;
    const account = accounts?.find((a) => a.id === valueToAssign.value);
    return account
        ? displayAccountLabel(account, showAccountNumbers)
        : undefined;
}
